export default {
  ACTIVE: 'Active',
  APPROVED: 'Approved',
  NOT_ACTIVATED: 'Not activated',
  BLOCKED: 'Blocked',
  CLOSED: 'Closed',
  status: 'Status',
  COMPLETED: 'Completed',
  PENDING: 'Pending',
  REJECTED: 'Rejected',
  REVERSED: 'Reversed',
  PROCESSING: 'Processing',
  AUTHORIZED: 'Authorized',
  CONSENT: 'Consent',
  INITIAL: 'Initial',
  IN_PROGRESS: 'In Progress',
  COMPLETED_WITH_ERRORS: 'With errors',
};
